import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';
import { type CardLayoutModelConstructorType } from '../../types';

export class Product extends Field {
  static subqueriesForModel(
    modelClass: CardLayoutModelConstructorType
  ): Record<string, any> {
    switch (modelClass.typename) {
      case 'Initiative':
        return { project: ['name'] };

      case 'Goal':
        return { project: ['name'] };

      default:
        return {};
    }
  }

  get title() {
    return `${terminology('Product')}`;
  }

  exampleContents(): FieldContentsData {
    return { text: `Example ${terminology('product')}` };
  }

  contentsForRecord(record): FieldContentsData {
    return { text: record.project?.name };
  }
}
